<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span> Boost Your SaaS Business with Minglepay’s Payment Gateway</div>
            <div class="banner_tips mt-40 fw-300">Supercharge your Software-as-a-Service (SaaS) platform with Minglepay’s seamless payment solutions. Focus on delighting your clients while we handle fast, secure, and scalable transactions to drive your growth.</div>
         </div>
       </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color2 ">What We Offer</div>
                <div class="title_tag color6">Top Features for Educational Platforms</div>
            </div>
          <div class="py-20" v-for="item in list1" :key="item.id">
              <div class="grid grid_md_gap grid_xs_gap" >
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_col_start" :class="[item.id==2?'order-2':'']">
                   
                    <div class="tab_left text-l p-20 h-100p  " v-for="i in item.tabs" :key="i.id">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img :src="i.icon" alt="" class="">
                        </div>
                        <div class="half_title color2">{{ i.title }}</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">{{ i.msg }}</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img :src="item.img" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container page_title_bag page_top">
        <div class="page_width">
            <div class="page_title py-80">
                <div class="title_name color1 ">How Does a SaaS Payment Gateway Work?</div>
                <div class="title_tag color1">Minglepay’s payment gateway acts as a secure bridge, efficiently transferring financial data between your clients, your platform, and banks. Powered by AI and machine-learning, our platform ensures every transaction is fast, safe, and optimized for your SaaS bus</div>
            </div>
        </div>
    </div>
     <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color2 ">Global Reach with Open Banking</div>
                <div class="title_tag color6">As a leading payment platform and open banking provider, Minglepay connects your SaaS business to major banks across the UK, EU, and beyond. Our solutions offer:</div>
            </div>
          <div class="py-20">
              <div class="grid grid_md_gap grid_xs_gap" >
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_col_start" >
                    <div class="tab_left text-l p-20 h-100p  " >
                        <div class="h-10px mb-20 bg_3 title_line"></div>
                        <div class="half_title color2">Seamless Transactions</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Enable instant payments with real-time fund availability.</div>
                    </div>
                    <div class="tab_left text-l p-20 h-100p  " >
                        <div class="h-10px mb-20 bg_3 title_line"></div>
                        <div class="half_title color2">Actionable Insights</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Leverage AI-powered analytics to understand and anticipate client needs.</div>
                    </div>
                    <div class="tab_left text-l p-20 h-100p  " >
                        <div class="h-10px mb-20 bg_3 title_line"></div>
                        <div class="half_title color2">Effortless Integration</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Our user-friendly APIs make it simple to integrate and scale your payment system.</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t43.png" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container bg-6 page_top">
        <div class="page_width">
            <div class="page_title py-80">
                <div class="title_name color1 ">How Does a Payment Gateway Work for Education?</div>
                <div class="title_tag color1">Minglepay’s payment gateway acts as a digital conductor, securely guiding financial data between learners, your platform, and banks. Powered by AI and machine-learning, our system delivers fast, secure, and efficient payment processing tailored for the education</div>
            </div>
        </div>
    </div>

    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            
       
          <div class="py-20" >
            <div class="page_title pt-30">
                <div class="title_name color2 ">FAQs</div>
                
            </div>
            <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_8 grid_xs_12 grid_sm_12 ">
                     <div class="faq_collapse">
                        <el-collapse v-model="activeName" accordion>
                          <el-collapse-item title="How quickly can I integrate Minglepay’s payment gateway?" name="1">
                            <div class="coll_item">Our streamlined APIs allow you to set up and start processing payments in hours.</div> 
                          </el-collapse-item>
                          <el-collapse-item title="Is Minglepay secure for SaaS transactions?" name="2">
                           <div class="coll_item">Yes, we prioritize security with PCI DSS compliance, encryption, and AI-driven fraud detection.</div>
                          </el-collapse-item>
                          <el-collapse-item title="Can I support clients in multiple countries?" name="3">
                           <div class="coll_item">Absolutely! Minglepay supports multiple currencies and connects with banks worldwide for global reach.</div>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t20.png" alt="">
                  </div>
                </div>

            </div>
          </div>
          <div class="pt-20 pb-80">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_5 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t44.png" alt="">
                  </div>
                </div>
                <div class="grid_md_7 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name color2 text-l">Tools to Transform Your SaaS Business</div>
                        <div class="title_tag color6 text-l">Experience the power of instant transactions, actionable analytics, and secure payment processing. With Minglepay, your SaaS platform can focus on innovation and growth while we take care of the payments.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tab1 from '../../assets/image/tb28.png'
import tab2 from '../../assets/image/tb29.png'
import tab3 from '../../assets/image/tb30.png'
import tab4 from '../../assets/image/tb31.png'
import tab5 from '../../assets/image/tb32.png'
import tab6 from '../../assets/image/tb33.png'


import icon1 from '../../assets/image/t41.png'
import icon2 from '../../assets/image/t42.png'


export default {
    data(){
        return{
            list1:[
                {title:"",img:icon1,id:1,tabs:[
                    {title:"Open Banking Advantage",msg:"Deliver a superior customer experience with secure, streamlined open banking payments.",icon:tab1,id:3},
                    {title:"Effortless Payment Processing",msg:"Simplify pay-ins and pay-outs with intuitive UX, smart routing, and a variety of popular payment methods.",icon:tab2,id:4},
                    {title:"Global Currency Support",msg:"Cater to clients worldwide with multi-currency transactions, making global expansion effortless.",icon:tab3,id:5},
                ]},
                {title:"",img:icon2,id:2,tabs:[
                    {title:"AI-Driven Analytics",msg:"Gain deep insights into client behavior with ready-to-use segmentation and forecasting tools.",icon:tab4,id:6},
                    {title:"Top-Tier Security",msg:"Ensure peace of mind with PCI DSS compliance, advanced encryption, and robust fraud prevention.",icon:tab5,id:7},
                    {title:"Scalable Solutions",msg:"From startups to enterprises, our flexible plans grow with your SaaS business.",icon:tab6,id:8},
                ]},
            ],
         
            activeName:'1',
        }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/db_bg4.png);
}
.bg-6{
    background-image:url( ../../../public/bg/bg6.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
}
.title_line{
    width: 120px;
    position: relative;
    &::before{
        content:'';
        width: 20px;
        background:$theme_color3;
        position: absolute;
        right: -38px;
        height: 10px;
    }
}
.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}
</style>